/* eslint-disable no-return-await */

/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_VARIANT_URL, COMMON_HEADER_CONFIG} from "../config";

class VariantService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchVariants = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_VARIANT_URL}/variants`,
        params: {
          size: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListVariants = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_VARIANT_URL}/variants`,
        params: {
          size: 100,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createVariant = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = data;

      const config = {
        method: "post",
        url: `${API_VARIANT_URL}/variant`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateVariant = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = data;

      const config = {
        method: "PUT",
        url: `${API_VARIANT_URL}/variant/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataUpdate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getVariant = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_VARIANT_URL}/variant/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteVariant = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_VARIANT_URL}/variant/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getVariantData = async () => {
    const url = `${API_VARIANT_URL}/variants?page=1&size=100`;
    const config = {
      headers: {
        ...COMMON_HEADER_CONFIG,
        Authorization: `Bearer ${this.getAccessToken()}`
      }
    };
    return await axios.get(url, config);
  };
}

const variantService = new VariantService();

export default variantService;
